var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gray-area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("sdr-breadcrumbs", {
            attrs: { active_item: "second", module: _vm.modulo },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "container shortcode travel-ideas" }, [
            _c(
              "h1",
              {
                staticClass: "idea-title",
                staticStyle: { "margin-bottom": "30px" },
              },
              [
                _vm._m(0),
                _vm._v(_vm._s(_vm.headline_step1[_vm.getCurrentLocale])),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("sdr-rebooking-bookingno-bookingdetails", {
            attrs: { modulo: _vm.modulo, mode: "rebookingpassengers" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar col-sms-6 col-sm-4 col-md-3" },
            [_c("sdr-contact-box")],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }